import { isRight } from 'fp-ts/lib/Either';
import { ThunkResult } from '../../../redux/configureStore';
import store from '../../../redux/startupScript';
import { UserInfoGateway } from '../../gateways/userInfoGateway.interface';
import { Preferences } from '../../models/preferencesModel';
import * as actionCreators from './actionCreators';

export const updateUserPreferencesUseCase =
    (preferences: Preferences): ThunkResult<void> =>
    async (dispatch, getState, { userInfoGateway }: { userInfoGateway: UserInfoGateway }) => {
        const { subscriptionId, country } = store.getState().auth.user;

        dispatch(actionCreators.Actions.userPreferencesFetching());
        const result = await userInfoGateway.updatePreferences(
            subscriptionId,
            country,
            preferences,
        );

        if (isRight(result)) {
            dispatch(actionCreators.Actions.userPreferencesRetrieved(result.right));
        } else {
            dispatch(actionCreators.Actions.userPreferencesFailed());
        }
    };

export const getUserDefaultPreferencesUseCase =
    (): ThunkResult<void> =>
    async (dispatch, getState, { userInfoGateway }: { userInfoGateway: UserInfoGateway }) => {
        const { country } = store.getState().auth.user;

        dispatch(actionCreators.Actions.userPreferencesFetching());
        const result = await userInfoGateway.getDefaultPreferences(country);
        if (isRight(result)) {
            dispatch(actionCreators.Actions.userPreferencesRetrieved(result.right));
        } else {
            dispatch(actionCreators.Actions.userPreferencesFailed());
        }
    };
